// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.bun/css-loader@7.1.4+018dfbff5b436835/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.bun/css-loader@7.1.4+018dfbff5b436835/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myWorkoutsAutocomplete {
  max-width: 100% !important;
}
.myWorkoutsAutocomplete div {
  max-width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/modules/providers/containers/workoutPlansTemplates/index.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".myWorkoutsAutocomplete {\n  max-width: 100% !important;\n}\n.myWorkoutsAutocomplete div {\n  max-width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
